import { render, staticRenderFns } from "./ClassLink.vue?vue&type=template&id=32cd72e2"
import script from "./ClassLink.vue?vue&type=script&lang=js"
export * from "./ClassLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports